import type { MarketType } from '@ps/web-sports-api-types';

const standardOddsBoostMarketTypeCodes = [
  'ODDS_BOOST',
  'POWER_PRICES',
  'DAILY_POWER_PRICES',
  'POWER_PRICE'
] as const satisfies Readonly<MarketType[]>;

const pssOddsBoostMarketTypeCodes = [
  'POWER_PRICES_PSSFR',
  'POWER_PRICES_PSSCOM',
  'POWER_PRICES_PSSBF'
] as const satisfies Readonly<MarketType[]>;

export type OddsBoostMarket = (
  | typeof standardOddsBoostMarketTypeCodes
  | typeof pssOddsBoostMarketTypeCodes
)[number];

export const getOddsBoostMarketTypeCodes = ({
  isPssOddsBoostMarketTypeCodesEnabled
}: {
  isPssOddsBoostMarketTypeCodesEnabled: boolean;
}): OddsBoostMarket[] => [
  ...standardOddsBoostMarketTypeCodes,
  ...(isPssOddsBoostMarketTypeCodesEnabled ? pssOddsBoostMarketTypeCodes : [])
];

export const isOddsBoostMarket = (
  isPssOddsBoostMarketTypeCodesEnabled: boolean,
  marketType?: MarketType
): marketType is OddsBoostMarket =>
  getOddsBoostMarketTypeCodes({ isPssOddsBoostMarketTypeCodesEnabled }).includes(
    marketType as OddsBoostMarket
  );
